import { isNull, isEmpty } from "lodash";
import getLimits from "@irati/checkout/utils/deal/getLimits";
import basket from "@irati/checkout/utils/basket";
import isOpenValue from "@irati/deals/helpers/deals/isOpenValue";
export default (function (deal) {
    if (isEmpty(deal)) {
        return true;
    }
    var numOfProducts = basket.items.length;
    var subtotal = basket.breakdown.total;
    var limits = getLimits(deal);
    var numItems = basket.items.reduce(function (acc, item) {
        return acc + (item.count || 1);
    }, 0);
    if (isOpenValue(deal) && basket.items[0]) {
        var openValue = basket.items[0].openValue / 100;
        return openValue < limits.minOpenValuePrice || openValue > limits.maxOpenValuePrice;
    }
    return ((numOfProducts > limits.numProducts && !isNull(limits.numProducts)) ||
        (subtotal > limits.maxPrice && !isNull(limits.maxPrice)) ||
        (subtotal < limits.minPrice && !isNull(limits.minPrice)) ||
        (numItems > limits.numItems && !isNull(limits.numItems)));
});
